enum SortDirections {
  Asc = "asc",
  Desc = "desc",
}
export default SortDirections;
